// see: https://raw.githubusercontent.com/aceakash/project-name-generator/master/src/generator.js

import { l } from '../../../lib/imports'
import { rando } from '../../../lib/rando-sidecar'
import { adjectives } from './adjectives'
import { nouns } from './nouns'

export function generate(options: any) {
  var defaults = {
    number: false,
    words: 2,
    alliterative: false,
  }
  options = l.merge(defaults, options || {})

  var raw = getRawProjName(options)
  raw[0] = raw[0][0].toUpperCase() + raw[0].substring(1)

  return {
    raw: raw,
    dashed: raw.join('-'),
    spaced: raw.join(' '),
  }
}

export function getRawProjName(options: any) {
  var raw: any[] = []
  l.times(options.words - 1, function () {
    if (options.alliterative && raw.length)
      raw.push(
        l.sample(getAlliterativeMatches(adjectives, raw[0].substring(0, 1))),
      )
    else raw.push(rando.sample(adjectives).toLowerCase())
  })

  if (options.alliterative)
    raw.push(l.sample(getAlliterativeMatches(nouns, raw[0].substring(0, 1))))
  else raw.push(rando.sample(nouns).toLowerCase())

  if (options.number) {
    raw.push(l.random(1, 9999))
  }
  return raw
}

function getAlliterativeMatches(arr: any, letter: any) {
  var check = letter.toLowerCase()
  return l.filter(arr, function (elm) {
    return elm.substring(0, 1).toLowerCase() === check
  })
}
